// Importar dependencias
import ApiClient from "./ApiClient";

const usersUrl = "users/";

// Función para registrar a un nuevo usuario
async function signUpOwner(user, business) {
  try {
    // Realizar petición al servidor
    const signUpResult = await ApiClient.post(usersUrl + "owner/sign-up", {
      user,
      business
    });

    return {
      token: signUpResult.headers["auth-token"],
      profile: signUpResult.data
    };
  } catch (err) {
    // Regresar error
    throw new Error(err.response.data.message);
  }
}

// Función para iniciar sesión
async function signIn(email, password) {
  try {
    // Realizar petición al servidor
    const signInResult = await ApiClient.post(usersUrl + "sign-in", {
      email,
      password
    });

    return {
      token: signInResult.headers["auth-token"],
      profile: signInResult.data
    };
  } catch (err) {
    // Regresar error
    throw new Error(err.response.data.message);
  }
}

// Función para obtener el perfil del usuario
async function getProfile() {
  // Realizar la petición al servidor
  const profileResult = await ApiClient.get(usersUrl + "me");
  return profileResult.data;
}

// Enviar correo de verificación
async function sendEmailVerification() {
  try {
    const responese = await ApiClient.post(
      usersUrl + "auth/send-email-verification"
    );

    return responese.data;
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

// Verificar correo electrónico
async function verifyEmail(token) {
  try {
    const response = await ApiClient.post(
      usersUrl + "auth/verify-email?token=" + token
    );

    return response.data;
  } catch (err) {
    throw new Error(err.response.data.message);
  }
}

export default {
  signUpOwner,
  signIn,
  getProfile,
  sendEmailVerification,
  verifyEmail
};
